<style>
</style>

<template>
	<div v-html="imgTag" />
</template>

<script>
// Note, QRCode script is loaded in public/index.html
export default {
	model: {
		prop: "qrcode",
		event: "change"
	},
	props: {
		qrcode: {
			type: String,
			default: ""
		},
		cellSize: {
			type: Number,
			default: 3
		}
	},
	data() {
		return {
			imgTag: "",
		}
	},
	created() {
		this.update_qrcode(this.qrcode)
	},
	methods: {
		update_qrcode(new_qrcode) {
			var qr = qrcode(0, 'M');
			qr.addData(new_qrcode);
			qr.make();
			this.imgTag = qr.createImgTag(this.cellSize,2);
		}
	},
	watch: {
		qrcode(new_qrcode) {
			update_qrcode(new_qrcode);
		},
		cellSize() {
			this.update_qrcode(this.qrcode);
		}
	}
}
</script>
